import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class InvoicesService {
	constructor(private _http: HttpClient) {
	}

	/**
	 * @api {post} /v2/Invoices/Email Email Invoice
	 * @apiName emailInvoice
	 * @apiGroup Invoices
	 * @apiVersion 20.0.0
	 */
	emailInvoice(data) {
		return this._http.post<any>(`${environment.apiUrl}/v2/Invoices/Email`, data);
	}

	/**
	 * @api {get} /v2/Customers/:custId/Invoices/:invoiceNumber/Generate Get Invoice
	 * @apiName getInvoice
	 * @apiGroup Invoices
	 * @apiVersion 20.0.0
	 */
	getInvoice(custId, invoiceNumber) {
		return this._http.get<Blob>(`${environment.apiUrl}/v2/Customers/${custId}/Invoices/${invoiceNumber}/Generate`, {responseType: 'blob' as 'json'});
	}

	/**
	 * @api {get} /v2/Invoices/Dates/:custId Get Invoice Dates
	 * @apiName getInvoiceDates
	 * @apiGroup Invoices
	 * @apiVersion 20.0.0
	 */
	getInvoiceDates(custId) {
		return this._http.get<any>(`${environment.apiUrl}/v2/Invoices/Dates/${custId}`);
	}

	/**
	 * @api {post} /v2/Invoices/Summaries/Search/:custId Get Invoice Summaries
	 * @apiName getInvoiceSummaries
	 * @apiParam {string} [year] Year
	 * @apiParam {string} [month] Month
	 * @apiParam {number} [partialInvoiceNum] Partial Invoice Number
	 * @apiParam {number} [numLookbackMonths] Number of Lookback Months
	 * @apiParam {number} [pageNum] Page Number
	 * @apiParam {number} [pageSize] Page Size
	 * @apiParam {string} [invoiceStatus] Invoice Status
	 * @apiGroup Invoices
	 * @apiVersion 21.1.0
	 */
	getInvoiceSummaries(custId, p) {
		let params: HttpParams = new HttpParams();
		const searchCriteria = [];

		if (p.yearAndMonth) {
			params = params.append('year', p.yearAndMonth.year);
			params = params.append('month', p.yearAndMonth.month);
		}

		if (p.search) {
			params = params.append('partialInvoiceNum', p.search);
		}

		if (p.lookbackRange) {
			params = params.append('numLookbackMonths', p.lookbackRange);
		}

		if (p.pageNum) {
			params = params.append('pageNum', p.pageNum);
		}

		if (p.pageSize) {
			params = params.append('pageSize', p.pageSize);
		}

		if (p.invoiceStatus) {
			searchCriteria.push({
				searchColumn: 'INVOICE_STATUS',
				searchValues: [p.invoiceStatus]
			});
		}
		return this._http.post<any>(`${environment.apiUrl}/v2/Invoices/Summaries/Search/${custId}`, searchCriteria, {params});
	}

	/**
	 * @api {post} /v2/Invoices/:custId/:invoiceId/Pay Pay Invoice
	 * @apiName payInvoice
	 * @apiGroup Invoices
	 * @apiVersion 21.1.0
	 */
	payInvoice(custId, invoiceId, creditCard) {
		return this._http.post<any>(`${environment.apiUrl}/v2/Invoices/${custId}/${invoiceId}/Pay`, creditCard);
	}

   /**
	 * @api {get} v2/Invoices/Email/AutoFill/{custId}/{invoiceId} Get Invoice Email
	 * @apiName getInvoiceEmail
	 * @apiGroup Invoices
	 * @apiVersion 20.0.0
	 */
	getInvoiceEmail(custId,invoiceId) {
		return this._http.get<any>(`${environment.apiUrl}/v2/Invoices/Email/AutoFill/${custId}/${invoiceId}/`);
	}
}
